<template>
    <div>
        <property-reservation-setup
            :setup_parameter="SETUP_PARAMETER_CURRENCY_SOURCE"></property-reservation-setup>
    </div>
</template>

<script>


import {SETUP_PARAMETER_CURRENCY_SOURCE} from "@/shared/constants";

export default {
    name: "Index",
    components: {
        "PropertyReservationSetup": () => import("@/components/property/reservation_setup/PropertyReservationSetup")
    },
    data() {
        return {
            SETUP_PARAMETER_CURRENCY_SOURCE
        }
    }
}
</script>

<style scoped>

</style>
